import { app } from '@/app';
import { addFavoriteMaterial as addFavorite } from '@/app/api/morgan-thermal/material/add-favorite';
import { MaterialInformation } from '@/app/api/morgan-thermal/material';

export const addFavoriteMaterial = (id: MaterialInformation['id']) => app.morganThermalAPI.fetch(addFavorite(id));